// ===============================
// 📁 urgenceUtils.js
// ===============================

import { toDate, isToday, diffDays } from "./dateUtils";

// 🔴 Séjour expiré (persistant)
export const isExpired = (item) => {
  if (!item?.date_fin_prevue) return false;

  const fin = toDate(item.date_fin_prevue);

  fin.setHours(12, 0, 0, 0);

  return (
    item.statut_reel === "occupe" &&
    new Date() > fin
  );
};

// 🟠 Urgence JOUR J (reste à payer)
export const isUrgentToday = (item) => {
  if (!item?.date_fin_prevue) return false;

  const fin = toDate(item.date_fin_prevue);

  return (
    item.statut_reel === "occupe" &&
    item.reste_a_payer > 0 &&
    isToday(fin)
  );
};

// 🟡 Urgence J-1
export const isUrgentJ1 = (item) => {
  if (!item?.date_fin_prevue) return false;

  const days = diffDays(toDate(item.date_fin_prevue), new Date());

  return (
    item.reste_a_payer > 0 &&
    days === 1
  );
};

// 🚨 Urgence globale (tous cas)
export const isUrgent = (item) => {
  return (
    isExpired(item) ||
    isUrgentToday(item) ||
    isUrgentJ1(item)
  );
};

// 🎯 Niveau d'urgence (utile pour UI)
export const getUrgenceLevel = (item) => {
  if (isExpired(item)) return "critique";
  if (isUrgentToday(item)) return "eleve";
  if (isUrgentJ1(item)) return "moyen";
  return "normal";
};

// 🎨 Classe CSS (optionnel UI)
export const getUrgenceStyle = (item) => {
  const level = getUrgenceLevel(item);

  switch (level) {
    case "critique":
      return "bg-black text-white animate-bounce";
    case "eleve":
      return "bg-red-500 text-white animate-pulse";
    case "moyen":
      return "bg-orange-400 text-white";
    default:
      return "";
  }
};
